import React, { Component } from "react";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroller";
import Header from "./header";
import down from "./../../../include/images/down-icon-1.svg";
import AvtarImage from "../../common/avtarImage";
import { withRouter } from "react-router-dom";
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { toast } from 'react-toastify'
import AlertSuccess from '../../common/alertSuccess'
import AlertError from '../../common/alertError'
import LeftBar from "./leftBar";
import moment from "moment";
import NoRecord from "../../common/noRecord";
import { getFeedback, loadfeedback, togglePublish } from "../../../store/feedback";

class Feedback extends Component {
  state = {
    step: 1,
    sidebarToogle: false,
    list_id: "",
    totalRecords: "",
    totalPages: "",
    pageLimit: "",
    currentPage: "",
    feedbackData: [],
    page: 1,
    pagination: {},
    loading: false,
    yesMindyMomentCount: "",
  };
  componentDidMount() {
    document.body.className = "dashboard";
    this.loadMoreFeedback()
  }

  loadMoreFeedback = async () => {
    if (this.state.loading) return;

    this.setState({ loading: true }, () => {
      const { page, feedbackData, pagination } = this.state;

      if (
        pagination.filtered_record &&
        feedbackData.length >= pagination.filtered_record
      ) {
        this.setState({ loading: false });
        return;
      }

      this.props.loadFeedback(
        {
          page: page,
        },
        this.callbackFeedback
      );
    });
  };

  callbackFeedback = (res) => {
    if (res && res.status === 200) {
      console.log("data res ---> ", res)
      const { data, pagination, yesmindy_moment_count } = res.data;
      this.setState(prevState => ({
        feedbackData: [...prevState.feedbackData, ...data],
        pagination,
        page: prevState.page + 1,
        loading: false,
        ...(yesmindy_moment_count !== undefined && {
          yesMindyMomentCount: yesmindy_moment_count,
        }),
      })) 
      } else {
        this.setState({
          loading: false,
      });
    }
  }
  toggleSidebar = (e) => {
    if (e) e.preventDefault();
    this.setState({ sidebarToogle: !this.state.sidebarToogle });
  };

  toggleDetail = (list_id) => {
    this.setState((prevState) => ({
      list_id: prevState.list_id === list_id ? "" : list_id,
    }));
  };

  publishCallback = res => {
    if (res.status === 200) {
      toast(<AlertSuccess message={'Information saved'} />)
      this.props.loadFeedback({page: this.state.page})
    } else {
      toast(<AlertError message={'Something went wrong'} />)
    }
  }
  render() {
    return (
      <div className={this.state.sidebarToogle ? "dashboard on" : "dashboard"}>
        <ReactTooltip className='testPurple' id='feedback-tooltip' />
        <LeftBar />
        <Header
          sidebarToogle={this.state.sidebarToogle}
          toggleSidebar={this.toggleSidebar}
        />
        <div className="dashboard-main-container">
          <div className="dashboard-wrapper">
            <div className="dashboard-single-panel">
              <div className="dsp-head d-flex align-items-center justify-content-between flex-wrap">
                <h4 className="mb-0">Feedback/Testimonials</h4>

                <div
                  className="d-flex align-items-center"
                  style={{
                    fontWeight: "700",
                    color: "#2D1B69",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "20px",
                      lineHeight: "1",
                    }}
                  >
                    YesMindy Moments{'  '}
                    <a
                      class='custom-dropdown-toggle'
                      href='#!'
                      onClick={e => e.preventDefault()}
                      data-tooltip-id='feedback-tooltip'
                      data-tooltip-content='When patients responded "YesMindy, I feel better"'>
                      <i
                        class='fas fa-info-circle fa-xs'
                        aria-hidden='true'></i>
                    </a>
                    {'  '}:{'  '}
                  </span>

                  <span
                    style={{
                      color: "#5b1cc1",
                      fontSize: "35px",
                      lineHeight: "1",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {this.state.yesMindyMomentCount}
                  </span>
                </div>
              </div>
              <div className="dsp-body">
                <div className="tab-container d-none d-md-block"></div>
                <div className="tab-content-box">
                  <div className="tab-content content-body show add-scrollbar  scrollbar-dynamic d-block" id="myTabContent">
                    <div
                      class="tab-pane card fade show active"
                      id="allpatients"
                      role="tabpanel"
                      aria-labelledby="allpatients-tab"
                    >
                      <div className="accordion" 
                        id="accordion1"
                        style={{ height: "700px", overflow: "auto" }}
                        ref={(ref) => (this.scrollParentRef = ref)}
                      >
                        <InfiniteScroll
                          pageStart={1}
                          initialLoad={false}
                          loadMore={this.loadMoreFeedback}
                          hasMore={
                            !this.state.loading &&
                            (
                              !this.state.pagination.filtered_record ||
                              this.state.feedbackData.length <
                                this.state.pagination.filtered_record
                            )
                          }
                          loader={
                            <div className="loader" key={0}>
                              Loading ...
                            </div>
                          }
                          useWindow={false}
                          getScrollParent={() => this.scrollParentRef}
                        >
                        {this.state.feedbackData.length > 0 ? (
                          this.state.feedbackData.map((e1, index) => (
                            <>                    
                            <div className="item mb-3" key={e1._id}>
                              {/* Accordion Header */}
                              <div
                                className={
                                  this.state.list_id === e1._id
                                    ? "ih-box"
                                    : "ih-box collapsed"
                                }
                                onClick={() => this.toggleDetail(e1._id)}
                                style={{ cursor: "pointer" }}
                              >
                                {/* <div className="d-flex justify-content-between align-items-center"> */}

                                <div class="slb-box d-flex flex-wrap">
                                  <div class="slb-img">
                                    <div class="person-img">
                                      {e1.patient_id.thumb ? (
                                        <img
                                          src={
                                            process.env.REACT_APP_S3URL +
                                            e1.patient_id.thumb
                                          }
                                          alt=""
                                        />
                                      ) : (
                                        <AvtarImage />
                                      )}
                                    </div>
                                  </div>
                                  <div class="slb-text">
                                    <h3>
                                      {e1.patient_id?.first_name}{" "}
                                      {e1.patient_id?.last_name}
                                    </h3>
                                    <p className="text-muted">
                                      {moment(
                                        e1.appointment_id.appointment_time,
                                      )
                                        .utc()
                                        .format("lll")}
                                    </p>
                                  </div>
                                </div>

                                <div class="slb-icons-outer d-flex align-items-center justify-content-end">
                                  <span
                                    style={{ cursor: "pointer" }}
                                    class="icon"
                                  >
                                    <i>
                                      <img src={down} alt="" />
                                    </i>
                                  </span>
                                </div>
                                {/* </div> */}
                              </div>

                              {/* Accordion Body */}
                              <div
                                className={
                                  this.state.list_id === e1._id
                                    ? "collapse show"
                                    : "collapse"
                                }
                              >
                                <div className="t-p p-4">
                                  {/* Ymmoment */}
                                  <div className="mb-4">
                                    <h5
                                      className="mb-3"
                                      style={{ fontWeight: "600" }}
                                    >
                                      Did patient feel better or positive after
                                      the last session ?
                                    </h5>

                                    <p className="mb-0">
                                      {e1.ymmoment === 1
                                        ? "YesMindy, I feel Better"
                                        : e1.ymmoment === 2
                                          ? "Didn't feel good"
                                          : "Can't say"}
                                    </p>
                                  </div>

                                  {/* Feedback */}
                                  <div className="mb-4">
                                    <h5
                                      className="mb-3"
                                      style={{ fontWeight: "600" }}
                                    >
                                      Detailed Feedback
                                    </h5>

                                    <p className="mb-0">{e1.feedback}</p>
                                  </div>
                                  {e1.is_publish_allowed && (
                                    <div className="d-flex justify-content-end">
                                      <button
                                        className={
                                          e1.featured_on_profile
                                            ? "btn btn-outline-secondary"
                                            : "btn btn-primary"
                                        }
                                        onClick={() =>
                                          this.props.togglePublish(
                                            e1._id,
                                            this.publishCallback
                                          )
                                        }
                                      >
                                        {e1.featured_on_profile
                                          ? "Unpublish"
                                          : "Publish"}
                                      </button>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div></>
                          ))
                        ) 
                        : (
                          <NoRecord
                            header="No Feedback Found"
                            text="No feedback/testimonials available yet."
                          />
                        )}
                        </InfiniteScroll>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  getFeedback: getFeedback(state).feedback,
});
const mapDispatchToProps = (dispatch) => ({
  loadFeedback: (params, callback = null) => dispatch(loadfeedback(params, callback)),
  togglePublish: (id, callback) => dispatch(togglePublish(id, callback)),
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Feedback),
);
